import { NumItemsBeingReturnedOption } from "@redotech/redo-model/return-flow/condition";
import { ConditionTypeDetailsProps } from "@redotech/redo-return-ui/flows/return-flow/condition";
import { ItemsBeingReturnedCountState } from "@redotech/redo-return-ui/flows/return-flow/condition-types/items-being-returned-count";
import { RedoTextInput } from "@redotech/redo-web/arbiter-components/input/redo-text-input";
import { RedoListItem } from "@redotech/redo-web/arbiter-components/list/redo-list";
import { RedoSingleSelectDropdownInput } from "@redotech/redo-web/arbiter-components/select-dropdown/redo-single-select-dropdown-input";
import { memo, useMemo } from "react";

export const ItemsBeingReturnedCountDetails = memo(
  function ItemsBeingReturnedCountDetails({
    state,
    setState,
    disabled,
  }: ConditionTypeDetailsProps<ItemsBeingReturnedCountState>) {
    const numItemsOptions: RedoListItem<NumItemsBeingReturnedOption>[] =
      useMemo(
        () =>
          Object.values(NumItemsBeingReturnedOption).map((option) => ({
            id: option,
            value: option,
            type: "text" as const,
            text: option,
          })),
        [],
      );

    const selectedOption = state.numItemsOption
      ? numItemsOptions.find((option) => option.value === state.numItemsOption)
      : undefined;

    return (
      <>
        <RedoSingleSelectDropdownInput
          disabled={disabled}
          flexGrow
          label="Match type"
          options={numItemsOptions}
          optionSelected={({ item }) =>
            setState({ ...state, numItemsOption: item.value })
          }
          placeholder="Select match type..."
          selectedItem={selectedOption}
          size="xs"
        />
        <RedoTextInput
          label="Number of items selected for return"
          min={0}
          onBlur={() =>
            setState({ ...state, numItems: (+state.numItems).toFixed(0) })
          }
          setValue={(e) => setState({ ...state, numItems: e })}
          state={disabled ? "readonly" : "default"}
          value={state.numItems}
        />
      </>
    );
  },
);
